import { render, staticRenderFns } from "./isi-content.vue?vue&type=template&id=2f62e07f&scoped=true&"
import script from "./isi-content.vue?vue&type=script&lang=ts&"
export * from "./isi-content.vue?vue&type=script&lang=ts&"
import style0 from "./isi-content.vue?vue&type=style&index=0&id=2f62e07f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62e07f",
  null
  
)

export default component.exports